import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Send a pageview event to Google Analytics
 */
export const trackPageView = (path, title) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title,
      page_location: window.location.href,
    });
  }
};

/**
 * Send a custom event to Google Analytics
 * @param {string} eventName - Name of the event
 * @param {object} params - Event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

// Which way a link reaches us, by its address; null for any other link
const contactMethod = (href) => {
  if (href.startsWith('https://wa.me/')) return 'whatsapp';
  if (href.startsWith('tel:')) return 'phone';
  if (href.startsWith('mailto:')) return 'email';
  return null;
};

/**
 * Hook to automatically track page views on route changes, and taps on any
 * WhatsApp, phone or email link (a "contact_click" event with the method)
 */
const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  // One listener for the whole page, so every contact link is counted without wiring each one
  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest && e.target.closest('a[href]');
      const method = link && contactMethod(link.getAttribute('href'));
      if (method) trackEvent('contact_click', { method, page_path: window.location.pathname });
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
};

export default useAnalytics;

